const map = {
	"./article-icon.svg": 835,
	"./brain.svg": 301,
	"./cart-icon.svg": 325,
	"./email-icon.svg": 405,
	"./expand.svg": 391,
	"./globe.svg": 314,
	"./headset-icon.svg": 715,
	"./headset.svg": 127,
	"./home-icon.svg": 728,
	"./home.svg": 278,
	"./iso-badge.png": 242,
	"./iso-badge.svg": 936,
	"./language.svg": 429,
	"./laptop-icon.svg": 807,
	"./laptop.svg": 91,
	"./lightbulb-icon.svg": 898,
	"./lightbulb.svg": 272,
	"./location-icon.svg": 464,
	"./logo-1.png": 180,
	"./logo-color.png": 792,
	"./mic.svg": 980,
	"./mind-icon.svg": 539,
	"./phone-icon.svg": 581,
	"./play.svg": 789,
	"./plug.svg": 975,
	"./profile-illustration.svg": 185,
	"./settings.svg": 756,
	"./smartphone.svg": 202,
	"./soc-badge.svg": 877,
	"./soc2-badge.png": 480,
	"./solar.svg": 230,
	"./tech-icon.svg": 699
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;